import Router from 'vue-router'
import Vue from 'vue'
import store from '../store'
import Home from '@/components/Home'
import About from '@/components/About'
import ECommercePulse from '@/components/ECommercePulse'
import Lighthouse from '@/components/Lighthouse'
import PressPage from '@/components/Press/PressPage'
// import Trsearchenginereadme from '@/components/TrSearchEngineReadMe'
// import Trwikireadme from '@/components/TrWikiReadMe'
// import CompanyReportsPage from '@/components/CompanyReports/CompanyReportsPage'
// import PoliciesPage from '@/components/Policies/PoliciesPage'
// import Ecommerce from '@/components/Ecommerce/Ecommerce'
// import Subscription from '@/components/Subscription/Subscription'
// import Access from '@/components/Access'
import AdminPanel from '@/components/AdminPanel/AdminPanel'
// import Webshop from '@/components/Webshop/Webshop'
// import Location from '@/components/Location/LocationPage'
import Wiki from '@/components/Wiki/Wiki'
import LOGGER from '@/graphql/Logger.gql'
import USER from '@/graphql/User.gql'
import Callback from '@/components/Callback'
import { apolloClient } from '../vue-apollo'

Vue.use(Router)
/* eslint no-console: ["error", { allow: ["warn", "error"] }] */
const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: false,
        label: 'Home'
      }
    },
    {
      path: '/about',
      name: 'about',
      component: About,
      meta: {
        requiresAuth: false,
        label: 'About'
      }
    },
    {
      path: '/e-commerce-pulse',
      name: 'e-commerce-pulse',
      component: ECommercePulse,
      meta: {
        requiresAuth: false,
        label: 'E-Commerce Pulse'
      }
    },
    {
      path: '/lighthouse',
      name: 'lighthouse',
      component: Lighthouse,
      meta: {
        requiresAuth: false,
        label: 'Lighthouse Index'
      }
    },
    // {
    //   path: '/tr-search-engine-readme',
    //   name: 'trSearchEngineReadme',
    //   component: Trsearchenginereadme,
    //   meta: {
    //     label: 'TR Search Engine - Read Me'
    //   }
    // },
    // {
    //   path: '/tr-wiki-readme',
    //   name: 'trWikiReadme',
    //   component: Trwikireadme,
    //   meta: {
    //     requiresAuth: false,
    //     label: 'TR Wiki - Read me'
    //   }
    // },
    {
      path: '/press',
      name: 'press',
      component: PressPage,
      meta: {
        requiresAuth: false,
        label: 'TR Search Engine - Press'
      }
    },
    {
      path: '/search/:search',
      name: 'search',
      component: PressPage,
      meta: {
        requiresAuth: false,
        label: 'TR Search Engine - Press'
      }
    },
    {
      path: '/smart-tag/:smartTag',
      name: 'smartTag',
      component: PressPage,
      meta: {
        requiresAuth: false,
        label: 'TR Search Engine - Press'
      }
    },
    // {
    //   path: '/ecommerce',
    //   name: 'ecommerce',
    //   component: Ecommerce,
    //   meta: {
    //     requiresAuth: true,
    //     label: 'TR Wiki - Retailer'
    //   }
    // },
    // {
    //   path: '/se-airport-shops',
    //   name: 'seAirportShops',
    //   component: Location,
    //   meta: {
    //     requiresAuth: true,
    //     label: 'TR Search Engine - Airport shops'
    //   }
    // },
    // {
    //   path: '/airport-shops',
    //   name: 'airportShops',
    //   component: Location,
    //   meta: {
    //     requiresAuth: true,
    //     label: 'TR Wiki - Airport shops'
    //   }
    // },
    {
      path: '/wiki',
      name: 'wiki',
      component: Wiki,
      meta: {
        requiresAuth: true,
        label: 'TR Wiki - Actors'
      }
    },
    // {
    //   path: '/webshop',
    //   name: 'webshop',
    //   component: Webshop,
    //   meta: {
    //     requiresAuth: true,
    //     label: 'Webshop'
    //   }
    // },
    // {
    //   path: '/subscription',
    //   name: 'subscription',
    //   component: Subscription,
    //   meta: {
    //     requiresAuth: false,
    //     label: 'Subscription'
    //   }
    // },
    // {
    //   path: '/access',
    //   name: 'access',
    //   component: Access,
    //   meta: {
    //     requiresAuth: false,
    //     label: 'Access'
    //   }
    // },
    {
      path: '/admin',
      name: 'admin',
      component: AdminPanel,
      meta: {
        requiresAuth: true,
        label: 'Admin panel'
      }
    },
    // {
    //   path: '/company-reports',
    //   name: 'companyReports',
    //   component: CompanyReportsPage,
    //   meta: {
    //     requiresAuth: true,
    //     label: 'TR Search Engine - Company Reports'
    //   }
    // },
    // {
    //   path: '/policies',
    //   name: 'policies',
    //   component: PoliciesPage,
    //   meta: {
    //     requiresAuth: true,
    //     label: 'TR Search Engine - Policies'
    //   }
    // },
    {
      path: '/callback',
      name: 'callback',
      component: Callback
    },
    {
      path: '*',
      redirect: '/'
    }
  ],
  mode: 'history'
})

router.beforeEach(async (to, from, next) => {
  apolloClient.mutate({
    mutation: LOGGER,
    variables: {
      level: 'info',
      message: JSON.stringify({
        action: 'route',
        from: from.name,
        to: to.name
      })
    }
  }).catch(error => {
    if (error.networkError.statusCode === 401) {
      Vue.prototype.$auth0.login()
    } else {
      store.commit('addError', error)
    }
  })

  // redirect non www to www except localhost and dev.
  if (window.location.origin !== 'http://localhost:8080') {
    if (window.location.origin !== 'https://dev.tr-toolbox.com') {
      if (window.location.origin !== 'https://www.tr-toolbox.com') {
        window.location.href = 'https://www.tr-toolbox.com'
      }
    }
  }
  if (to.name === 'callback' || to.meta.requiresAuth === undefined || to.meta.requiresAuth === false) {
    next()
  } else if (to.meta.requiresAuth === true && (!!localStorage.getItem('id_token') === false || Vue.prototype.$auth0.isAuthenticated() === false)) {
    // if require authenticated and not connected
    store.commit('setLoginSignupForm', true)
    // if (to.path === '/') {
    //   Vue.prototype.$auth0.login()
    // } else {
    //   Vue.prototype.$auth0.login()
    //   // redirect to / because this is the authorised callback url on auth0
    //   //  window.location.href = window.location.origin
    // }
  } else {
    // if not connected
    apolloClient.query({ query: USER }).then(response => {
      if (response.data.user.acl_app_access.indexOf(to.name) > -1) {
        // user can have access to this page
        next()
      } else {
        window.location.href = window.location.origin
      }
    }).catch((error) => {
      if (error.networkError.statusCode === 401) {
        Vue.prototype.$auth0.login()
      } else {
        store.commit('addError', error)
      }
    })
  }
})

export default router
